import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import FileInput from "../Form/FileInput";

const SchemaUploadForm = ({
  onFileChange,
  onSubmit,
  values,
  touched,
  errors,
}) => (
  <>
    <Row>
      <Col lg={4} className="mb-3">
        <FileInput
          values={values}
          onChange={onFileChange}
          label="Dodaj Skicu"
          formName="images"
          accept="image/jpg, image/jpeg"
          errors={errors}
          touched={touched}
        />
      </Col>
    </Row>
    <Row>
      <Col lg={3}>
        <Button className="btn btn-primary" onClick={onSubmit}>
          Dodaj Slike
        </Button>
      </Col>
    </Row>
  </>
);

export default SchemaUploadForm;
